import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';
import * as S from './Footer.styles';

/**
 * Componente Footer que incluye información de contacto y enlaces
 * Mantiene la consistencia visual con el resto de la página
 */
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <S.FooterSection>
      <S.Container>
        <S.FooterContent>
          <S.FooterSectionItem>
            <S.FooterTitle>Dra. Suni Wiphala Chipana Flores</S.FooterTitle>
            <S.FooterSubtitle>Medicina Integral</S.FooterSubtitle>
            <S.FooterDescription>
              Formación integral en prevención, promoción, manejo y rehabilitación 
              de la salud con enfoque en salud pública comunitaria.
            </S.FooterDescription>
          </S.FooterSectionItem>

          <S.FooterSectionItem>
            <S.FooterTitle>Contacto</S.FooterTitle>
            <S.ContactList>
              <S.ContactItem>
                <S.ContactIcon>
                  <FaPhone />
                </S.ContactIcon>
                <S.ContactText>+56 9 9224 7167</S.ContactText>
              </S.ContactItem>
              <S.ContactItem>
                <S.ContactIcon>
                  <FaEnvelope />
                </S.ContactIcon>
                <S.ContactText>
                  <a href="mailto:dra.suni.chipanaflores@gmail.com">dra.suni.chipanaflores@gmail.com</a>
                </S.ContactText>
              </S.ContactItem>
              <S.ContactItem>
                <S.ContactIcon>
                  <FaMapMarkerAlt />
                </S.ContactIcon>
                <S.ContactText>Santiago de Chile</S.ContactText>
              </S.ContactItem>
            </S.ContactList>
          </S.FooterSectionItem>

          <S.FooterSectionItem>
            <S.FooterTitle>Servicios</S.FooterTitle>
            <S.ServicesList>
              <S.ServiceItem>Control Climaterio</S.ServiceItem>
              <S.ServiceItem>Control Hipotiroidismo</S.ServiceItem>
              <S.ServiceItem>Control Diabetes Mellitus 2</S.ServiceItem>
              <S.ServiceItem>Control Hipertensión Arterial</S.ServiceItem>
              <S.ServiceItem>Control Dislipidemia</S.ServiceItem>
              <S.ServiceItem>Control Obesidad</S.ServiceItem>
              <S.ServiceItem>Control Resistencia a la Insulina</S.ServiceItem>
              <S.ServiceItem>Consulta Morbilidad</S.ServiceItem>
            </S.ServicesList>
          </S.FooterSectionItem>
        </S.FooterContent>

        <S.FooterBottom>
          <S.Copyright>
            © {currentYear} Dra. Suni Wiphala Chipana Flores. Todos los derechos reservados.
          </S.Copyright>
          <S.MadeWith>
            Hecho con <FaHeart /> para tu salud
          </S.MadeWith>
        </S.FooterBottom>
      </S.Container>
    </S.FooterSection>
  );
};

export default Footer; 